import { AuditEntry } from '../PanelComerciales.types';

/** Identifica al operador del panel. Cuando el JWT esté disponible viene de auth. */
const FALLBACK_USER = 'panel.comerciales@propiedades.com';

const SHORT_MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

const formatNow = (now: Date = new Date()): string =>
    `${now.getDate()} ${SHORT_MONTHS[now.getMonth()]} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

export const buildAuditEntry = (
    action: string,
    detail: string,
    user: string = FALLBACK_USER,
): AuditEntry => ({
    date: formatNow(),
    user,
    action,
    detail,
});
